import { Alert } from '@mui/material';

interface FormSuccessMessageProps {
  message: string;
}

function FormSuccessMessage(props: FormSuccessMessageProps) {
  const { message } = props;

  return (
    <Alert
      sx={{
        backgroundColor: 'success.main',
        color: 'primary.contrastText',
      }}
      variant="filled"
      severity="success"
    >
      {message}
    </Alert>
  );
}

export default FormSuccessMessage;
